export default class EnvironmentConfig {
  get baseURL(): string {
    const isLocalhost =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' || 
      window.location.hostname.endsWith('.localhost')

    const port = isLocalhost ? ':8000' : ''
    const url = `${window.location.protocol}//${window.location.hostname}${port}/o/api/`

    return url
  }
}
